module.exports = __webpack_public_path__ + "img/sombra_esq_campos_login.c6a72149.png";